/**
 * row per page enum
 */
export enum RowPerPageEnum {
    TEN    = 'TEN',
    TWENTY = 'TWENTY',
    FIFTY  = 'FIFTY',
    ONE_HUNDRED  = 'ONE_HUNDRED',
    TWO_HUNDRED  = 'TWO_HUNDRED',
    THREE_HUNDRED  = 'THREE_HUNDRED',
}

export const NumberRPPE = {
    10: RowPerPageEnum.TEN,
    20: RowPerPageEnum.TWENTY,
    50: RowPerPageEnum.FIFTY,
    100: RowPerPageEnum.ONE_HUNDRED,
    200: RowPerPageEnum.TWO_HUNDRED,
    300: RowPerPageEnum.THREE_HUNDRED,
};
export const RPPENumber = {
    [RowPerPageEnum.TEN]: 10,
    [RowPerPageEnum.TWENTY]: 20,
    [RowPerPageEnum.FIFTY]: 50,
    [RowPerPageEnum.ONE_HUNDRED]: 100,
    [RowPerPageEnum.TWO_HUNDRED]: 200,
    [RowPerPageEnum.THREE_HUNDRED]: 300,
};
